import { Pipe, PipeTransform } from '@angular/core';
import { EmployeeCaseOption } from '@core/models';

@Pipe({
    name: 'caseOptionFormatBanks',
    standalone: false
})

export class CaseOptionFormatBanksPipe implements PipeTransform {
  transform(eco: EmployeeCaseOption, availableBankHoursSysText: string): string {
    let hoursText = "", banksText = "";
    const b1 = eco.showBank1Hours, b2 = eco.showBank2Hours, b3 = eco.showBank3Hours, b4 = eco.showBank4Hours, b5 = eco.showBank5Hours;
    if (b1) {
      banksText += eco.bank1Name;
      hoursText += (eco.remainingBank1Leave ?? "--");
    }
    if (b2) {
      banksText += (b1 ? " / " : "") + eco.bank2Name;
      hoursText += (b1 ? " / " : "") + (eco.remainingBank2Leave ?? "--");
    }
    if (b3) {
      banksText += (b1 || b2 ? " / " : "") + eco.bank3Name;
      hoursText += (b1 || b2 ? " / " : "") + (eco.remainingBank3Leave ?? "--");
    }
    if (b4) {
      banksText += (b1 || b2 || b3 ? " / " : "") + eco.bank4Name;
      hoursText += (b1 || b2 || b3 ? " / " : "") + (eco.remainingBank4Leave ?? "--");
    }
    if (b5) {
      banksText += (b1 || b2 || b3 || b4 ? " / " : "") + eco.bank5Name;
      hoursText += (b1 || b2 || b3 || b4 ? " / " : "") + (eco.remainingBank5Leave ?? "--");
    }
    return availableBankHoursSysText.replace("@[bank]", banksText) + ": " + hoursText;
  }
}